import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

// EZ
import { UiLibraryModule } from '@template-ui/template-ui.module';
import { EzFormInputType, InputConfig } from "@template-ui/types";
import { DocMeta } from "@template-ui/decorators";

// BITS
import { AppBaseComponent } from "@app/shared/components/app-base.component";
import { CaseSummaryBarComponent } from "../case-summary-bar.component";
import { IWorkflowSummary } from "../case-summary-bar.types";

@DocMeta({
  hide: true,
  showcaseTitle: "Investigation",
})
@Component({
    selector: 'app-case-summary-bar-sample',
    templateUrl: './case-summary-bar-sample.component.html',
    styleUrl: './case-summary-bar-sample.component.scss',
    imports: [
        CommonModule,
        UiLibraryModule,
        CaseSummaryBarComponent
    ]
})
export class CaseSummaryBarSampleComponent extends AppBaseComponent implements OnInit {
  protected readonly inputConfig: InputConfig[] = [
    {
      name: 'caseId',
      type: EzFormInputType.NUMBER,
      label: "Case Id",
    }
  ];

  protected formValues = { caseId: 42 };

  public ngOnInit(): void {
    this.bitsState.caseSummarySignal.set(this.buildMockSummary(this.formValues.caseId));
  }

  protected onFormValuesChange(values: Record<string, unknown>): void {
    const caseId = (values['caseId'] as number) ?? 0;
    this.formValues = { caseId };
    this.bitsState.caseSummarySignal.set(this.buildMockSummary(caseId));
  }

  private buildMockSummary(caseId: number): IWorkflowSummary {
    return {
      workflowName: 'BPH Full Investigation',
      caseId,
      caseNum: `INV-${caseId}`,
      workflowStepName: 'Attorney Review',
      workflowStepStatus: 'In Progress',
      workflowData: [
        '|',
        { label: 'Plan Due to Legal', value: '06/15/2026' },
        { label: 'Final Due Date', value: '08/01/2026' },
        { label: 'Assigned Attorney', value: 'Smith, J.' },
        { label: 'Assigned Investigator', value: 'Jones, M.' },
        { label: 'Referred On', value: '01/10/2026' },
        { label: 'Referred By', value: 'Doe, J.' },
      ],
    };
  }
}